const vehicles = {
  table: {
    headers: {
      supplier: 'Flotten',
    },
    filters: {
      supplier: 'Flotten',
    },
  },

  form: {
    information: {
      details: {
        fields: {
          suppliers: 'Flotten',
        },
      },

      suppliers: {
        header: 'Flotten',
        fields: {
          suppliers: 'Flotten',
        },
      },
    },
  },
};

export default vehicles;
